<script>
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

import {
  getOpportunities,
  exportOpportunities,
  patchOpportunity,
  getOpportunityComments,
  postOpportunityComment,
  createWorkOrder,
  getOpportunityDeviceTypes,
  statisticsBusiness,
  statisticsPlan,
} from "@/service";
import {
  formatDatetime,
  getTimezone,
  getLastDateOfMonth,
  getLabel,
  // toUtcFormat
} from "@/helpers/common";
import {
  BUSINESS_STATUS_LIST,
  BUSINESS_STATUS_PENDING,
  BUSINESS_STATUS_FINISHED,
  BUSINESS_STATUS_CONVERTED,
  BUSINESS_DELAY_REASON,
  WO_TYPE_EQUIPMENT_MAINTENANCE,
  WO_STATUS_COMPLETED,
  WO_STATUS_CANCELLED,
  APP_INDUSTRY_LIST,
} from "@/config/common";
import _ from "lodash";
import TableLoading from "@/views/widgets/table-loading";
import { maintenanceItemList } from "@/utils/selectText";
import notesModal from "@/views/business-opportunity/components/notesModal";
import { getDeviceInfo } from "@/helpers/common-service";
import moment from "moment";
import { alertComfirm } from "@/helpers/swal";
import { CountTo } from "vue3-count-to";
import CancelModal from "@/views/work-order/components/widgets/cancel-modal";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    source: {
      type: String,
      default: "", // 'maintain' or 'business'
    },
  },
  data() {
    return {
      BUSINESS_STATUS_LIST,
      BUSINESS_STATUS_PENDING,
      BUSINESS_STATUS_CONVERTED,
      APP_INDUSTRY_LIST,
      /* 分页start */
      tab_info_length: 0,
      page: 1,
      perPage: 10,
      prePageOption: [10, 20, 30, 40, 50],
      pages: [],
      /* 分页end */
      value: null,
      status: null,
      status1: "",
      checkTabVal: "",

    tabOptionsCustomer: [
      {
        value: 4,
        text: "未开始",
        icon: "ri-time-fill",
        tipNum: 0,
      },
      {
        value: 5,
        text: "执行中",
        icon: "ri-arrow-right-circle-fill",
        tipNum: 0,
      },
      {
        value: 6,
        text:"已完成",
        icon: "ri-checkbox-circle-fill",
        tipNum: 0,
      },
      {
        value: 7,
        text:"已延期",
        icon: "ri-checkbox-circle-fill",
        tipNum: 0,
      },

      {
        value: "",
        text: this.$t("page.all"),
        icon: "ri-apps-line",
        tipNum: 0,
      },
    ],
      tabOptions: [
        {
          value: BUSINESS_STATUS_PENDING,
          text: this.$t("page.business-status.pending"),
          icon: "ri-time-fill",
          tipNum: 0,
        },
        {
          value: BUSINESS_STATUS_CONVERTED,
          text: this.$t("page.business-status.converted"),
          icon: "ri-arrow-right-circle-fill",
          tipNum: 0,
        },
        {
          value: BUSINESS_STATUS_FINISHED,
          text: this.$t("page.business-status.completed"),
          icon: "ri-checkbox-circle-fill",
          tipNum: 0,
        },
        {
          value: "",
          text: this.$t("page.all"),
          icon: "ri-apps-line",
          tipNum: 0,
        },
      ],
      showAllColumns: false,
      tableHeaders: [
        // 商机编号
        {
          name: "number",
          label: this.$t("page.business-number"),
          visible: true,
        },
        // 工单编号
        {
          name: "order_number",
          label: this.$t("page.work-order.number"),
          visible: true,
        },
        // 工单类型
        // {
        //   name: 'wo_type',
        //   label: this.$t('page.work-order.type.text'),
        //   visible: false
        // },
        // 保养名称
        {
          name: "expect_maintain_name",
          label: this.$t("page.maintenance-name"),
          visible: true,
        },
        // 设备类型
        {
          name: "device_profile_name",
          label: this.$t("page.device-type"),
          visible: true,
        },
        {
          name: "device_root_sn",
          label: this.$t("page.work-order.device-root-sn"),
          visible: true,
        },
        {
          name: "device_name",
          label: this.$t("page.work-order.device-name"),
          visible: false,
        },
        {
          name: "status",
          label: this.$t("page.status"),
          visible: true,
        },
        {
          name: "delay_status_txt",
          label: this.$t("page.delay-status"),
          visible: true,
        },
        {
          name: "delay_reason",
          label: this.$t("page.delay-or-complete-reason"),
          visible: true,
        },
        {
          name: "customer_contact_name",
          label: this.$t("page.work-order.contact"),
          visible: true,
        },
        {
          name: "customer_contact_number",
          label: this.$t("page.work-order.contact-phone"),
          visible: true,
        },
        // 行业
        {
          name: "industry",
          label: this.$t("page.industry"),
          visible: true,
        },
        {
          name: "customer_txt",
          label: this.$t("page.work-order.customer-name"),
          visible: true,
        },
        {
          name: "service_company_txt",
          label:JSON.parse(localStorage.getItem("user"))&&JSON.parse(localStorage.getItem("user")).user_type==='customer'?this.$t("page.service-provider"):this.$t("page.service-company"),
          visible: true,
        },
        {
          name: "expect_at",
          label: JSON.parse(localStorage.getItem("user"))&&JSON.parse(localStorage.getItem("user")).user_type==='customer'?this.$t("page.suggest-service-time"):this.$t("page.expected-service-time"),
          visible: true,
        },
        {
          name: "actual_complete_at",
          label: this.$t("page.business-finish-time"),
          visible: true,
        },
      ],
      visibleFields: [], // 显示的字段，按点击的顺序展示
      tableLoading: false,
      tableLoaded: false,
      orders: [],
      count: 0,
      // 默认查询期望服务时间为当年的记录，先按延期状态倒序排（已延期先出现），再按期望服务时间升序排
      filters: {
        page: 1,
        page_size: 10,
        status: BUSINESS_STATUS_PENDING,
        // expect_at_after: formatDatetime(
        //   new Date(new Date().getFullYear(), 0, 1),
        //   "YYYY-MM-DD"
        // ),
        // expect_at_before: formatDatetime(
        //   new Date(new Date().getFullYear(), 11, 31),
        //   "YYYY-MM-DD"
        // ),
        ordering: "-is_delay,expect_at",
      },
      filter_value: {
        keyword: "",
        status: BUSINESS_STATUS_PENDING,
        expect_at:"", //不显示时间，默认展示所有数据，注意分页请求
        // expect_at: [
        //   formatDatetime(new Date(new Date().getFullYear(), 0, 1), "YYYY-MM"),
        //   formatDatetime(new Date(new Date().getFullYear(), 11, 31), "YYYY-MM"),
        // ],
        actual_complete_at: "",
        // 保养名称
        maintain_name: null,
        // 设备类型
        device_profile_name: null,
      },
      checkedIds: [],
      checkedAll: false,
      maintenanceNameOptions: maintenanceItemList.map((item) => {
        return {
          value: item.value,
          label: item.label,
        };
      }),
      deviceTypeOptions: [],
      delayReasonOptions: [
        {
          value: "",
          label: this.$t("page.business-delay-reason.-1"),
          disabled: true,
        },
        ...BUSINESS_DELAY_REASON,
      ],
      // 转化为工单加载中状态
      tranferLoading: false,
      currentId: null,
      cancelTransferLoading: false,

      topCardList: [
        {
          name: this.$t("page.business.Channel1"),
          name1: this.$t("page.business.OrderValueThisMonth"),
          name2: this.$t("page.business.OrderVolumeThisMonth"),
          value: 0,
          value1: 0,
          icon:' ri-money-cny-circle-line'
        },
        {
          name: this.$t("page.business.Channel2"),
          name1: this.$t("page.business.EstimatedOrderValueThisMonth"),
          name2: this.$t("page.business.OrderVolumeThisMonth"),
          value: 0,
          value1: 0,
          icon:'ri-list-settings-line'

        },
        {
          name: this.$t("page.business.Channel3"),
          name1: this.$t("page.business.EstimatedOrderValueThisMonth"),
          name2: this.$t("page.business.OrderVolumeThisMonth"),
          value: 0,
          value1: 0,
          icon:'ri-apps-line'

        },
        {
          name: this.$t("page.business.Channel4"),
          name1: this.$t("page.business.EstimatedOrderValueThisMonth"),
          name2: this.$t("page.business.OrderVolumeThisMonth"),
          value: 0,
          value1: 0,
          icon:'mdi-numeric-4-box-multiple-outline'

        },
      ],
      topCardListPlan: [
        {
          name: this.$t("page.business['本月返厂大修计划']"),
          name1: this.$t("page.business['待转化工单']"),
          name2: this.$t("page.business['已转化工单']"),
          name3:  this.$t("page.business['已完成']"),
          name4: this.$t("page.business['全部返厂大修计划']"),
          value: 0,
          value1: 0,
          value2: 0,
          value3: 0,
          value4: 0,
          icon:' ri-arrow-go-back-line'
        },
        {
          name:this.$t("page.business['本月一级保养计划']"),
          name1: this.$t("page.business['待转化工单']"),
          name2: this.$t("page.business['已转化工单']"),
          name3:  this.$t("page.business['已完成']"),
          name4: this.$t("page.business['全部一级保养计划']"),
          value: 0,
          value1: 0,
          value2: 0,
          value3: 0,
          value4: 0,
          icon:' ri-hammer-line'

        },
        {
          name: this.$t("page.business['本月二级保养计划']"),
          name1: this.$t("page.business['待转化工单']"),
          name2: this.$t("page.business['已转化工单']"),
          name3:  this.$t("page.business['已完成']"),
          name4: this.$t("page.business['全部二级保养计划']"),
          value: 0,
          value1: 0,
          value2: 0,
          value3: 0,
          value4: 0,
          icon:' ri-tools-fill'

        },
        {
          name: this.$t("page.business['延期保养计划']"),
          name1: this.$t("overview_dynamic.service_type_dict['返厂大修']"),
          name2: this.$t("overview_dynamic.service_type_dict['一级保养']"),
          name3: this.$t("overview_dynamic.service_type_dict['二级保养']"),
          name4: this.$t("page.business['全部延期保养计划']"),
          value: 0,
          value1: 0,
          value2: 0,
          value3: 0,
          value4: 0,
          icon:' ri-clockwise-2-line'

        },
      ],
      cancelModalObj: {
        show: false,
        title: this.$t('page.business-delay-reason.5'),
        showCancelReason: false,
        cancelReasonRequired: false,
        selectedCancelReason: null,
        itemId: null,
      },
    };
  },
  components: {
    TableLoading,
    Multiselect,
    notesModal,
    CountTo,
    CancelModal,
  },
  computed: {
    visibleTableHeaders() {
      // 默认显示全部
      if (!this.showAllColumns) {
        return _.cloneDeep(this.tableHeaders);
      }
      // 根据点击的顺序展示
      return _.map(this.visibleFields, (fieldName) =>
        _.find(this.tableHeaders, ["name", fieldName])
      );
    },
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
  },
  mounted() {
    this._getFirstPage();
    this.getDeviceTypeOptions();
    if (this.$route.path.includes("business-opportunity")) {
      this.getStatisticsBusiness();
    } else {
      this.getStatisticsPlan();
    }
    console.log("APP_INDUSTRY_LIST",APP_INDUSTRY_LIST);
    
  },
  methods: {
    getStatisticsBusiness() {
      statisticsBusiness().then((res) => {
        if (res && res.payload) {
          this.topCardList.map((item) => {
            if (item.name == this.$t("page.business.Channel1")) {
              item.value = res.payload["channel_1_count"];
              item.value1 = res.payload["channel_1_value"];
            }
            if (item.name == this.$t("page.business.Channel2")) {
              item.value = res.payload["channel_2_count"];
              item.value1 = res.payload["channel_2_value"];
            }
            if (item.name == this.$t("page.business.Channel3")) {
              item.value = res.payload["channel_3_count"];
              item.value1 = res.payload["channel_3_value"];
            }
            if (item.name == this.$t("page.business.Channel4")) {
              item.value = res.payload["channel_4_count"];
              item.value1 = res.payload["channel_4_value"];
            }
          });
        }
      });
    },
    getStatisticsPlan() {
      statisticsPlan().then((res) => {
        if (res && res.payload) {
          this.topCardListPlan.map((item) => {
            if (item.name == '本月返厂大修计划') {
              item.value = res.payload["month_plan_3_count"];
              item.value1 = res.payload["month_plan_3_todo"];
              item.value2 = res.payload["month_plan_3_converted"];
              item.value3 = res.payload["month_plan_3_completed"];
              item.value4 = res.payload["total_plan_3"];
            }
            if (item.name == '本月一级保养计划') {
             item.value = res.payload["month_plan_1_count"];
              item.value1 = res.payload["month_plan_1_todo"];
              item.value2 = res.payload["month_plan_1_converted"];
              item.value3 = res.payload["month_plan_1_completed"];
              item.value4 = res.payload["total_plan_1"];
            }
            if (item.name == '本月二级保养计划') {
             item.value = res.payload["month_plan_2_count"];
              item.value1 = res.payload["month_plan_2_todo"];
              item.value2 = res.payload["month_plan_2_converted"];
              item.value3 = res.payload["month_plan_2_completed"];
              item.value4 = res.payload["total_plan_2"];
            }
            if (item.name == '延期保养计划') {
             item.value = res.payload["month_overdue_plan_count"];
              item.value1 = res.payload["month_overdue_plan_3"];
              item.value2 = res.payload["month_overdue_plan_1"];
              item.value3 = res.payload["month_overdue_plan_2"];
              item.value4 = res.payload["total_overdue_plan"];
            }
          });
        }
      });
    },
    formatDatetime,
    getLabel,
    getStatusClass(status) {
      const item = BUSINESS_STATUS_LIST.find((i) => i.value === status);
      if (!item) {
        return "";
      }
      return item.class;
    },
    // 商机是否可撤回转化
    isRevertable(item) {
      if (item.status != BUSINESS_STATUS_CONVERTED) {
        return false;
      }
      if (
        [WO_STATUS_COMPLETED, WO_STATUS_CANCELLED].includes(item.order_status)
      ) {
        return false;
      }
      if (item.order_is_checkin === "True") {
        return false;
      }
      return true;
    },
    // 设置显示列
    changeShowAllColumns() {
      this.tableHeaders.forEach((i) => {
        i.visible = this.showAllColumns;
      });
      if (!this.showAllColumns) {
        this.visibleFields = [];
      } else {
        this.visibleFields = _.map(this.tableHeaders, "name");
      }
    },
    changeShowColumn(fieldName) {
      if(this.tableHeaders.every(header=>header.visible)){
        this.showAllColumns = true
      }else{
        this.showAllColumns = false
      }
      let result = []
      this.tableHeaders.map(item=>{
        if(item.visible){
          result.push(item.name)
        }
      })
      this.visibleFields = result
      // this.visibleFields = _.xor(this.visibleFields, [fieldName]);
    },
    checkAllChange() {
      if (this.checkedAll) {
        // 将所有ID追加到数组并去重
        this.checkedIds = _.uniq(
          _.concat(this.checkedIds, _.map(this.orders, "id"))
        );
      } else {
        this.checkedIds = [];
      }
    },
    checkChange(id) {
      this.checkedIds = _.xor(this.checkedIds, [id]);
    },
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      this.tab_info_length = this.count;
      let numberOfPages = Math.ceil(this.count / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    // 延期原因改变
    delayReasonChange(delay_reason, id) {
      const form = {
        id: id,
        delay_reason: delay_reason,
      };
      if (delay_reason == 5) {
        // 显示延期原因说明弹窗，填写备件金额和备件说明
        this.cancelModalObj.itemId = id
        this.cancelModalObj.selectedCancelReason = delay_reason
        this.cancelModalObj.show = true
      } else {
        patchOpportunity(form)
          .then(() => {
            this.$message.success(this.$t("base.save_success"));
          })
          .catch((err) => {
            this.$message.error(err);
          });
      }

    },
    // 延期原因说明弹窗确认后
    cancelModalConfirm(params) {
      const form = {
        id: this.cancelModalObj.itemId,
        delay_reason: this.cancelModalObj.selectedCancelReason,
        spare_parts_amount: params.spare_parts_amount,
        spare_parts_desc: params.spare_parts_desc,
      };
      patchOpportunity(form)
        .then(() => {
          postOpportunityComment({
            task: this.cancelModalObj.itemId,
            content: params.reason_desc,
          })
            .then(() => {
              this.$message.success(this.$t("base.save_success"));
              this.cancelModalObj.show = false
            })
            .catch((err) => {
              console.log(err)
              this.$message.error('保存说明失败');
            });
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    delayReasonText(val) {
      const item = _.find(this.delayReasonOptions, ["value", val]);
      if (!item) {
        return this.$t("page.business-delay-reason.-1");
      }
      return item.label;
    },
    handleTransferClick(item) {
      if (item.status != BUSINESS_STATUS_PENDING) {
        return;
      }
      alertComfirm(this.$t("page.business-confirm-transfer")).then((res) => {
        if (!res) return;
        this.transfer(item);
      });
    },
    // 转化工单
    transfer(item) {
      item.expectation_at = item.expect_at
      if(!(item.customer_contact && item.customer_contact_number)
        || (item.customer_contact_name == "请完善" && item.customer_contact_number =="请完善") ){
        localStorage.setItem('serviceData', JSON.stringify(item))
        //跳转新建工单页面
        this.$router.push({
          path:"/work-order-add/1",
          query: {
            create:true,
            task_id:item.id
          },
        }); 
        return;
      }else{
        // 加载中状态
        if (this.tranferLoading) {
          return;
        }
        this.tranferLoading = true;
        this.currentId = item.id;
        const form = {
          type: WO_TYPE_EQUIPMENT_MAINTENANCE,
          // 维护保养名称
          maintain_name: item.expect_maintain_name,
          // customer id
          customer: item.customer,
          customer_address: item.customer_address,
          customer_contact: item.customer_contact,
          customer_contact_number: item.customer_contact_number,
          device_root_sn: item.device_root_sn || item.device_group_sn,
          device_name: item.device_name,
          device_id: item.device_id,
          priority: 1,
          expectation_at: item.expect_at,
          plan_start_at: null,
          plan_end_at: null,
          content: "-",
          // 维护项
          save_maintain_item_ids: [],
          // 服务商ID
          service_company: item.service_company,
          main_engineer: null,
          assist_engineer: null,
          attachment: [],
          // 转工单的服务请求ID
          service_request: null,
          task_id: item.id,
        };
        // 获取设备对应的维护项
        getDeviceInfo(
          item.device_root_sn || item.device_group_sn,
          false,
          false,
          true
        )
          .then((res) => {
            form.save_maintain_item_ids = res.repairs
              .filter((r) => r.name == form.maintain_name)
              .map((m) => m.id);
            // 新建工单
            createWorkOrder(form)
              .then((res) => {
                if (![200, 201].includes(res.meta.code)) {
                  this.tranferLoading = false;
                  this.$message.error(
                    this.$t("page.work-order.create-order-failed") +
                      "." +
                      res.meta.message
                  );
                  return;
                }
                // 改商机状态
                const form1 = {
                  id: item.id,
                  status: BUSINESS_STATUS_CONVERTED,
                  work_order: res.payload.id,
                  // transform_at: toUtcFormat(moment().format('YYYY-MM-DD HH:mm:ss'))
                  transform_at: moment().format("YYYY-MM-DD"),
                };
                patchOpportunity(form1)
                  .then(() => {
                    this.$message.success(this.$t("base.operate_success"));
                    this._getList();
                    this.tranferLoading = false;
                    // 新打开tab页跳转到工单详情
                    const route = this.$router.resolve({
                      path: `/work-order-detail/${form1.work_order}`,
                    });
                    window.open(route.href, "_blank");
                  })
                  .catch((err) => {
                    this.tranferLoading = false;
                    this.$message.error(this.$t("page.errorOccurred"));
                    console.log(err);
                  });
              })
              .catch((err) => {
                this.tranferLoading = false;
                this.$message.error(
                  this.$t("page.work-order.create-order-failed")
                );
                console.log(err);
              });
          })
          .catch((err) => {
            this.tranferLoading = false;
            console.log(err);
            this.$message.error(this.$t("page.get-maintenance-item-fail"));
          });
      }

    },
    // 撤回
    cancelTransfer(item) {
      if (!this.isRevertable(item)) {
        return;
      }
      alertComfirm(this.$t("page.business-confirm-cancel-transfer")).then(
        (res) => {
          if (!res) return;
          this.cancelTransferLoading = true;
          this.currentId = item.id;
          const form = {
            id: item.id,
            status: BUSINESS_STATUS_PENDING,
          };
          patchOpportunity(form)
            .then(() => {
              this.$message.success(this.$t("base.operate_success"));
              this._getList();
              this.cancelTransferLoading = false;
            })
            .catch((err) => {
              this.cancelTransferLoading = false;
              this.$message.error(this.$t("page.errorOccurred"));
              console.log(err);
            });
        }
      );
    },
    // 导出
    download() {
      // 当前的筛选条件：this.filters， 当前选择的字段：this.visibleTableHeaders
      const keyMap = {
        delay_status_txt: "is_delay",
      };
      // columns是一个字典，格式如：{key:title}，从this.visibleTableHeaders中获取name作为columns的key,label作为columns的title，且需要将priority,status的key转换为priority_txt,status_txt，engineer的key转换为main_engineer_txt
      let columns = _.map(this.visibleTableHeaders, (item) => {
        const key = keyMap[item.name] || item.name;
        return {
          [key]: item.label,
        };
      });
      columns = _.assign({}, ...columns);
      // param的格式如：{key:value}，从this.filters中获取key作为param的key,value作为param的value，删除page和page_size，删除value为null的key
      const param = _.omitBy(
        _.mapValues(this.filters, (value, key) => {
          if (key === "page" || key === "page_size") {
            return null;
          }
          return value;
        }),
        _.isNull
      );
      const langs = {
        expect_maintain_name: maintenanceItemList.reduce(
          (acc, { value, label }) => {
            acc[value] = label;
            return acc;
          },
          {}
        ),
        status: BUSINESS_STATUS_LIST.reduce((acc, { value, label }) => {
          acc[value] = label;
          return acc;
        }, {}),
        is_delay: {
          1: this.$t("page.overdue"),
          0: this.$t("page.not-overdue"),
        },
        delay_reason: this.delayReasonOptions.reduce(
          (acc, { value, label }) => {
            acc[value] = label;
            return acc;
          },
          {}
        ),
        industry: APP_INDUSTRY_LIST.reduce((acc, { value, label }) => {
          acc[value] = label;
          return acc;
        }, {}),
      };
      const params = {
        params: param,
        columns,
        langs,
        tz: getTimezone(),
        file_name:
          this.source === "business"
            ? this.$t("page.business-opportunity-download-title")
            : this.$t("page.maintenance-download-title"),
      };
      exportOpportunities(params).then((res) => {
        window.open(
          "/service-report-download/" +
            res.payload.request_id +
            "?type="+this.source,
          "_blank",
          "noreferrer"
        );
      });
    },
    refresh(currentPage) {
      if (currentPage) {
        // 只刷新当前页，筛选条件和页码都不变
        this._getList();
      } else {
        // 刷新整个页面的数据
        this.filter_value.status = null;
        this.resetSearch();
      }
    },
    // 筛选
    doFilter() {
      this.orders = [];
      const search = {
        keyword: null,
        expect_at_after: null,
        expect_at_before: null,
        status: null,
        actual_complete_at_after: null,
        actual_complete_at_before: null,
        maintain_name: null,
        device_profile_name: null,
      };
      if (this.filter_value.status) {
        search["status"] = this.filter_value.status;
      }
      if (this.filter_value.keyword) {
        search["keyword"] = this.filter_value.keyword;
      }
      if (this.filter_value.expect_at) {
        search["expect_at_after"] = `${this.filter_value.expect_at[0]}-01`;
        search["expect_at_before"] = getLastDateOfMonth(
          this.filter_value.expect_at[1]
        );
      }
      if (this.filter_value.actual_complete_at) {
        search[
          "actual_complete_at_after"
        ] = `${this.filter_value.actual_complete_at[0]}-01`;
        search["actual_complete_at_before"] = getLastDateOfMonth(
          this.filter_value.actual_complete_at[1]
        );
      }
      if (this.filter_value.maintain_name) {
        search["maintain_name"] = this.filter_value.maintain_name;
      }
      if (this.filter_value.device_profile_name) {
        search["device_profile_name"] = this.filter_value.device_profile_name;
      }

      this.filters = _.assign(this.filters, search);
      this._getFirstPage();
    },
    // 重置
    resetSearch() {
      this.filter_value.status = BUSINESS_STATUS_PENDING;
      this.filter_value.expect_at = null
      // this.filter_value.expect_at = [
      //   formatDatetime(new Date(new Date().getFullYear(), 0, 1), "YYYY-MM"),
      //   formatDatetime(new Date(new Date().getFullYear(), 11, 31), "YYYY-MM"),
      // ];
      this.filter_value.keyword = null;
      this.filter_value.actual_complete_at = null;
      this.filter_value.maintain_name = null;
      this.filter_value.device_profile_name = null;
      this.doFilter();
    },
    // 状态筛选
    checkTab(val) {
      this.filter_value.status = val;
      this.doFilter();
    },
    // 翻页
    pageChange(val) {
      this.filters.page = val;
      this._getList();
    },
    // 设置每页条数
    pageSizeChange(val) {
      this.filters.page_size = val;
      this._getFirstPage();
    },
    // 获取数据
    _getFirstPage() {
      this.page = 1;
      this.filters.page = 1;
      this.checkedAll = false;
      this.checkedIds = [];
      this._getList();
    },
    _getList() {
      this.filters.page_size = this.perPage;
      this.tableLoading = true;
      this.tableLoaded = false;
      this.orders = [];
      /* 默认状态下，不进行时间的筛选 */

      getOpportunities(this.filters)
        .then((res) => {
          this.tableLoading = false;
          this.tableLoaded = true;
          this.orders = res.payload.results.map((item) => {
            if (!item.delay_reason) {
              item.delay_reason = "";
            }
            return item;
          });
          this.count = res.payload.count;
          // 如果是全选状态，将当前页的所有ID追加到数组并去重
          if (this.checkedAll) {
            this.checkedIds = _.uniq(
              _.concat(this.checkedIds, _.map(this.orders, "id"))
            );
          }

          this.setPages();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 打开说明编辑和查看
    openNotes(task_id) {
      getOpportunityComments({
        task: task_id,
        page_size: 0,
      })
        .then((res) => {
          this.$refs.notesModal.open({
            task_id,
            notes: res.payload,
          });
        })
        .catch((err) => {
          this.$message.error(this.$t("page.get-explain-fail"));
          console.log(err);
        });
    },
    // 新增说明
    saveNote(params) {
      postOpportunityComment(params)
        .then(() => {
          this.$message.success(this.$t("page.add-explain-success"));
          this.$refs.notesModal.close();
          this._getList();
        })
        .catch((err) => {
          this.$message.error(this.$t("page.add-explain-fail"));
          console.log(err);
        });
    },
    // 获取设备类型选项
    getDeviceTypeOptions() {
      getOpportunityDeviceTypes()
        .then((res) => {
          this.deviceTypeOptions = res.payload.results;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {},
};
</script>

<template>
  <div>
    <b-row v-if="$route.path.includes('business-opportunity')&&user&&user.user_type!=='customer'">
      <b-col v-for="a in topCardList" :key="a.name" xxl="3" sm="6">
        <b-card no-body class="card-animate">
          <b-card-body>
            <div class="d-flex justify-content-between">
              <div>
                <p class="fw-medium text-muted mb-0">{{ a.name }}</p>
                <h2
                  class="mt-2 ff-secondary fw-semibold d-flex align-items-center"
                >
                  <h5 class="m-0 mt-1">{{ a.name1 }}:</h5>
                  ¥<count-to
                    :startVal="0"
                    :endVal="a.value"
                    :duration="5000"
                  ></count-to
                  >K
                </h2>
                <p class="mb-0 text-muted">
                  {{ a.name2 }}:<b-badge
                    class="bg-light mt-2 text-success mb-0 me-2"
                  >
                    {{ a.value1 }}
                  </b-badge>
                </p>
              </div>
              <div>
                <div class="avatar-sm flex-shrink-0">
                  <span
                    class="avatar-title bg-soft-info text-info rounded-circle fs-4"
                  >
                    <i :class="a.icon"></i>
                  </span>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="!$route.path.includes('business-opportunity')&&user&&user.user_type!=='customer'">
      <b-col v-for="a in topCardListPlan" :key="a.name" xxl="3" sm="6">
        <b-card no-body class="card-animate">
          <b-card-body>
            <div class="d-flex justify-content-between">
              <div style="width: 65%">
                <p class="fw-medium text-muted mb-0">{{ a.name }}</p>
                 <h3 class="ff-secondary fw-semibold">
                    <count-to
                      :startVal="0"
                      :endVal="a.value"
                      :duration="5000"
                    ></count-to>
                  </h3>
                <div class="w-100 mt-2 d-flex justify-content-between">
                  <h3 class="ff-secondary fw-semibold">
                    <h5 class="m-0 mt-1">{{ a.name1 }}</h5>
                    <count-to
                      :startVal="0"
                      :endVal="a.value1"
                      :duration="5000"
                    ></count-to>
                  </h3>
                  <h5 class="m-0 mt-1">|</h5>
                  <h3 class="ff-secondary fw-semibold">
                    <h5 class="m-0 mt-1">{{ a.name2 }}</h5>
                    <count-to
                      :startVal="0"
                      :endVal="a.value2"
                      :duration="5000"
                    ></count-to>
                  </h3>
                  <h5 class="m-0 mt-1">|</h5>
                  <h3 class="ff-secondary fw-semibold">
                    <h5 class="m-0 mt-1">{{ a.name3 }}</h5>
                    <count-to
                      :startVal="0"
                      :endVal="a.value3"
                      :duration="5000"
                    ></count-to>
                  </h3>
                </div>
                <p class="mb-0 text-muted">
                  {{ a.name4 }} : <b-badge
                    class="bg-light mt-2 text-success mb-0 me-2"
                  >
                    {{ a.value4 }}
                  </b-badge>
                </p>
              </div>
              <div>
                <div class="avatar-sm flex-shrink-0">
                  <span
                    class="avatar-title bg-soft-info text-info rounded-circle fs-4"
                  >
                    <i :class="a.icon"></i>
                  </span>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-card no-body id="orderList">
          <b-card-header class="border-0">
            <b-row class="align-items-center gy-3">
              <b-col cols="sm">
                <h5 class="card-title mb-0">{{ title }}</h5>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex gap-1 flex-wrap">
                  <div class="btn-group" role="group">
                    <b-button
                      type="button"
                      variant="outline-primary"
                      class="ms-1 dropdown-toggle"
                      data-bs-toggle="dropdown"
                      id="btnGroup1"
                      aria-expanded="false"
                    >
                      <i class="ri-settings-3-line align-bottom me-1"></i>
                      {{ $t("page.set-column") }}
                    </b-button>
                    <ul class="dropdown-menu" aria-labelledby="btnGroup1">
                      <li class="dropdown-item accordion-button-class" @click.capture.stop>
                        <label>
                          <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="showAllColumns"
                            @change="changeShowAllColumns"
                          />
                          {{ $t("base.select-all") }}
                        </label>
                      </li>
                      <li
                        v-for="(item, index) in tableHeaders"
                        :key="index"
                        class="dropdown-item accordion-button-class"
                        @click.capture.stop
                      >
                        <label>
                          <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="item.visible"
                            @change="changeShowColumn(item.name)"
                          />
                          {{ item.label }}
                        </label>
                      </li>
                    </ul>
                  </div>

                  <b-button
                    type="button"
                    variant="primary"
                    class="ms-1"
                    @click="download"
                  >
                    <i class="ri-download-cloud-2-line align-bottom me-1"></i>
                    {{ $t("base.export") }}
                  </b-button>
                  <!--                  <b-button type="button" variant="primary" class="add-btn" @click="add" v-perm="'order.post'">-->
                  <!--                    <i class="ri-add-line align-bottom me-1"></i> {{ $t('base.add') }}-->
                  <!--                  </b-button>-->
                </div>
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body class="border border-dashed border-end-0 border-start-0">
            <b-form>
              <b-row class="g-3">
                <b-col
                  xxl="2"
                  class="d-flex justify-content-start align-items-end"
                >
                  <div class="search-box w-100">
                    <input
                      type="text"
                      class="form-control search"
                      v-model="filter_value.keyword"
                      :placeholder="`${$t('page.work-order.device-name')}${(user&&user.user_type==='customer'?'':('/'+$t(
                  'page.customer_name'
                )))}/${$t('page.work-order.contact')}/${$t(
                        'page.work-order.contact-phone'
                      )}/${$t('page.industry')}/${$t('page.service-company')}`"
                    />
                    <i class="ri-search-line search-icon"></i>
                  </div>
                </b-col>
                <b-col xxl="3"  class="d-flex align-items-end">
                  <div class="form-group  flex-1">
                    <div class="input-group align-items-center">
                      <label class="mb-0"
                        >{{ user&&user.user_type==='customer'?$t("page.suggest-service-time"):$t("page.expected-service-time") }}：</label
                      >
                      <el-date-picker
                        v-model="filter_value.expect_at"
                        type="monthrange"
                        format="YYYY-MM"
                        value-format="YYYY-MM"
                        :range-separator="$t('base.to')"
                        :start-placeholder="$t('page.begin-month')"
                        :end-placeholder="$t('page.end-month')"
                      >
                      </el-date-picker>
                    </div>
                  </div>
                </b-col>
                <b-col xxl="3" class="d-flex align-items-end">
                  <div class="form-group flex-1">
                    <div class="input-group align-items-center">
                      <label class="mb-0"
                        >{{ $t("page.business-finish-time") }}：</label
                      >
                      <el-date-picker
                        v-model="filter_value.actual_complete_at"
                        type="monthrange"
                        format="YYYY-MM"
                        value-format="YYYY-MM"
                        :range-separator="$t('base.to')"
                        :start-placeholder="$t('page.begin-month')"
                        :end-placeholder="$t('page.end-month')"
                      >
                      </el-date-picker>
                    </div>
                  </div>
                </b-col>
                <b-col
                  xxl="1"
                  class="d-flex justify-content-start align-items-end"
                >
                  <div class="input-light w-100">
                    <Multiselect
                      class="form-control"
                      :placeholder="$t('page.maintenance-name')"
                      v-model="filter_value.maintain_name"
                      :close-on-select="true"
                      :searchable="false"
                      :create-option="false"
                      :options="maintenanceNameOptions"
                      :can-clear="false"
                    />
                  </div>
                </b-col>
                <b-col
                  xxl="1"
                  class="d-flex justify-content-start align-items-end"
                >
                  <div class="input-light w-100">
                    <Multiselect
                      class="form-control"
                      :placeholder="$t('page.device-type')"
                      v-model="filter_value.device_profile_name"
                      :close-on-select="true"
                      :searchable="false"
                      :create-option="false"
                      :options="deviceTypeOptions"
                      :can-clear="false"
                    />
                  </div>
                </b-col>
                <b-col xxl="2" class="d-flex justify-content-end align-items-end">
                    <b-button
                      type="button"
                      variant="primary"
                      @click="doFilter"
                      class="me-2"
                    >
                      <i class="ri-search-line me-1 align-bottom"></i>
                      {{ $t("search") }}
                    </b-button>
                    <b-button type="button" variant="info" @click="resetSearch">
                      <i class="ri-restart-line me-1 align-bottom"></i>
                      {{ $t("base.reset") }}
                    </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
          <b-card-body class="pt-0">
            <div>
              <ul
                class="nav nav-tabs nav-tabs-custom nav-success mb-3"
                role="tablist"
              >
                <li
                  class="nav-item"
                  v-for="(tabItem, index) in user&&user.user_type==='customer'?tabOptionsCustomer:tabOptions"
                  :key="index"
                >
                  <b-link
                    class="nav-link py-3"
                    :class="
                      tabItem.value == filter_value.status ? 'active' : ''
                    "
                    data-bs-toggle="tab"
                    role="tab"
                    @click.prevent="checkTab(tabItem.value)"
                    aria-selected="true"
                  >
                    <i :class="tabItem.icon" class="me-1 align-bottom"></i>
                    {{ tabItem.text }}
                    <b-badge
                      v-if="tabItem.tipNum > 0"
                      variant="danger"
                      class="align-middle ms-1"
                      >{{ tabItem.tipNum }}</b-badge
                    >
                  </b-link>
                </li>
              </ul>
              <div class="table-responsive table-card mb-1">
                <table class="table table-nowrap align-middle" id="orderTable">
                  <thead class="text-muted table-light">
                    <tr class="text-uppercase">
                      <!--                      <th scope="col" style="width: 25px">-->
                      <!--                        <div class="form-check">-->
                      <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                      <!--                        </div>-->
                      <!--                      </th>-->
                      <template
                        v-for="(item, index) in visibleTableHeaders"
                        :key="index"
                      >
                        <th v-show="item.visible&&(user&&user.user_type!=='customer'||(user&&user.user_type==='customer'&&item.label!==$t('page.work-order.customer-name')))">{{ item.label }}</th>
                      </template>
                      <th>{{ $t("base.operation") }}</th>
                    </tr>
                  </thead>
                  <tbody class="list form-check-all">
                    <tr
                      v-for="(item, index) in orders"
                      :key="index"
                      :class="[item.is_delay && 'highlight']"
                    >
                      <!--                      <th scope="row">-->
                      <!--                        <div class="form-check">-->
                      <!--                          <input class="form-check-input" type="checkbox" name="chk_child" :checked="checkedIds.includes(item.id)" @change="checkChange(item.id)" />-->
                      <!--                        </div>-->
                      <!--                      </th>-->
                      <template
                        v-for="(titleItem, titleIdx) in visibleTableHeaders"
                        :key="titleIdx"
                      >
                        <td v-show="titleItem.visible&&(user&&user.user_type!=='customer'||(s))">
                          <span
                            v-if="['status'].includes(titleItem.name)"
                            :class="getStatusClass(item['status'])"
                            >{{
                              getLabel(BUSINESS_STATUS_LIST, item.status)
                            }}</span
                          >
                          <router-link
                            v-else-if="titleItem.name == 'order_number'"
                            :to="'/work-order-detail/' + item['work_order']"
                            target="_blank"
                            >{{ item[titleItem.name] || "-" }}</router-link
                          >
                          <!--            延期状态            -->
                          <div
                            v-else-if="titleItem.name === 'delay_status_txt'"
                          >
                            <div>
                              <span
                                v-if="item['is_delay']"
                                class="badge badge-soft-danger dot-prefix"
                              >
                                {{ $t("page.overdue") }}
                              </span>
                              <span
                                v-else
                                class="badge badge-soft-success dot-prefix"
                                >{{ $t("page.not-overdue") }}</span
                              >
                            </div>
                            <div class="d-flex align-content-center">
                              <template v-if="!item.last_comment">
                                <span class="text-muted">{{
                                  $t("page.no-explain")
                                }}</span>
                                <!--                              <b-link class="ms-2 text-decoration-underline" @click.prevent="openNotes(item.id)">{{ $t('page.add-explain') }}</b-link>-->
                              </template>
                              <template v-else>
                                <span
                                  v-b-tooltip.hover
                                  :title="item.last_comment"
                                  class="note_content"
                                  @click.prevent="openNotes(item.id)"
                                  >{{ item.last_comment }}</span
                                >
                                <!--                              <b-link class="ms-2 text-decoration-underline" @click.prevent="openNotes(item.id)">{{ $t('page.view-more') }}</b-link>-->
                              </template>
                            </div>
                          </div>
                          <!--          延期原因               -->
                          <div
                            v-else-if="titleItem.name === 'delay_reason'"
                            style="width: 150px;"
                          >
<!--                            <b-form-input-->
<!--                              v-if="!item.is_delay"-->
<!--                              size="sm"-->
<!--                              disabled-->
<!--                              placeholder="不需填写"-->
<!--                            ></b-form-input>-->
                            <div
                              v-b-tooltip.hover
                              :title="delayReasonText(item.delay_reason)"
                              class="cursor-pointer"
                            >
                              <el-select
                                v-model="item.delay_reason"
                                size="small"
                                :placeholder="$t('also.please select')"
                                @change="(e) => delayReasonChange(e, item.id)"
                                :teleported="false"
                                >
                                <el-option
                                  v-for="item in delayReasonOptions"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                  :disabled="item.disabled"
                                >
                                </el-option>
                              </el-select>
                            </div>
                          </div>
                          <!--          序列号               -->
                          <span
                            v-else-if="titleItem.name === 'device_root_sn'"
                            >{{
                              item.device_root_sn || item.device_group_sn
                            }}</span
                          >
                          <!--          完成时间               -->
                          <span
                            v-else-if="titleItem.name === 'actual_complete_at'"
                            >{{
                              formatDatetime(item.actual_complete_at, "YYYY-MM")
                            }}</span
                          >
                          <!--          期望时间               -->
                          <span v-else-if="titleItem.name === 'expect_at'">{{
                            formatDatetime(item.expect_at, "YYYY-MM")
                          }}</span>
                          <!--   保养名称                        -->
                          <span
                            v-else-if="
                              titleItem.name === 'expect_maintain_name'
                            "
                            >{{
                              getLabel(
                                maintenanceNameOptions,
                                item.expect_maintain_name
                              )
                            }}</span
                          >
                          <!--   行业                     -->
                          <span v-else-if="titleItem.name === 'industry'">{{
                            getLabel(APP_INDUSTRY_LIST, item.industry)
                          }}</span>
                          <span v-else>{{ item[titleItem.name] }}</span>
                        </td>
                      </template>
                      <td>
                        <div class="d-flex align-items-center action-style">
                          <div
                            class="me-2 cursor-pointer"
                            :class="[
                              item.status != BUSINESS_STATUS_PENDING &&
                                'disabled',
                            ]"
                            @click="handleTransferClick(item)"
                          >
                            <span
                              v-if="tranferLoading && item.id === currentId"
                              class="mdi mdi-loading mdi-spin"
                            ></span>
                            <span
                              v-else
                              class="mdi mdi-reply-all transfer"
                            ></span>
                          </div>
                          <div
                            class="me-2 cursor-pointer"
                            @click="openNotes(item.id)"
                          >
                            <span class="mdi mdi-message-processing"></span>
                          </div>
                          <!--      必须是已转化且还没有进入施工中才能点撤回（未签到就表示没有进入施工中）                  -->
                          <div
                            :class="[!isRevertable(item) && 'disabled']"
                            class="me-2 cursor-pointer"
                            @click="cancelTransfer(item)"
                          >
                            <span
                              v-if="
                                cancelTransferLoading && currentId === item.id
                              "
                              class="mdi mdi-loading mdi-spin"
                            ></span>
                            <span v-else class="mdi mdi-reply-all"></span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table-loading
                  :count="count"
                  :table-loading="tableLoading"
                  :table-loaded="tableLoaded"
                ></table-loading>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <Pagination
      v-if="tab_info_length"
      v-model:page="page"
      v-model:perPage="perPage"
      :pages="pages"
      :prePageOption="prePageOption"
      :tab_info_length="tab_info_length"
      @update:page="pageChange"
      @update:perPage="pageSizeChange"
      class="me-5 my-3"
    ></Pagination>
    <!--  说明弹窗   -->
    <notes-modal ref="notesModal" @saveNote="saveNote"></notes-modal>
    <!-- 延期原因选择后弹出的备件金额、备件说明、原因说明弹窗   -->
    <cancel-modal
      :title="cancelModalObj.title"
      :show="cancelModalObj.show"
      :show-cancel-reason="cancelModalObj.showCancelReason"
      :cancel-reason-required="cancelModalObj.cancelReasonRequired"
      :selected-cancel-reason="cancelModalObj.selectedCancelReason"
      @ok="cancelModalConfirm"
      @cancel="cancelModalObj.show = false"
    ></cancel-modal>
  </div>
</template>

<style lang="scss">
.multiselect-multiple-label,
.multiselect-placeholder,
.multiselect-single-label {
  padding-right: 1.25rem !important;
}
.date-filter-group {
  border: var(--ms-border-width, 1px) solid var(--ms-border-color, #d1d5db);
  border-radius: 4px;
  padding: 0 1px;
  .flatpickr-input {
    border: none !important;
    border-radius: 4px !important;
  }
  .multiselect {
    border: none !important;
    border-radius: 4px !important;
  }
}

.dot-prefix {
  display: flex;
  align-items: center;
  width: fit-content;
  &::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #f06548;
    margin-right: 0.125rem;
  }
}
.dot-prefix.badge-soft-success::before {
  background-color: #1abc9c;
}
.note_content {
  display: inline-block;
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.action-style {
  color: #38477e;
  font-size: 18px;
  .transfer::before {
    transform: rotate(180deg);
  }
  .disabled {
    color: #e9ebec;
  }
}
.highlight {
  //background-color: #e5d4b5a3;
  background-color: rgba(241, 206, 202, 0.2);
}
.el-date-editor.el-input,
.el-date-editor.el-input__wrapper {
  height: 37.5px !important;
}
</style>
